import React from 'react';
import { Element } from 'react-scroll';
import receiveImage from './assets/receive.png';
import payImage from './assets/pay.png';
import chooseImage from './assets/choose.png';
import partnerImage from './assets/partner.png';
import styles from './styles.scss';

function HowItWorks () {
  return (
    <div className="mb100">
      <Element name="how-it-works" />
      <div className="row">
        <div className="col-md-8 col-md-offset-2">
          <div className="text-center mt100">
            <h1>
              It's simple. And fast.
            </h1>
            <p className={`alt-text light ls1 ${styles.easyHeading}`}>
              Getting great app design shouldn't be hard.
              Easily submit a brief and we’ll reserve your design team.
            </p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className={styles.howItWorks}>
          <ul className={styles.list}>
            <li>
              <div className={`${styles.number} bold`}>1</div>
              <div className={styles.image}><img src={chooseImage} alt="choose a package" /></div>
              <div className={styles.description}>
                <h3 className="bold">submit a brief for mobile, app, or web design</h3>
                <p className="lsh">
                  Easily choose a pricing package, ask us questions, and send a quick brief about your project.
                </p>
              </div>
            </li>
            <li>
              <div className={`${styles.number} bold`}>2</div>
              <div className={styles.image}><img src={payImage} className={styles.budge} alt="easy payments" /></div>
              <div className={styles.description}>
                <h3 className="bold">pay easily to reserve your design team</h3>
                <p className="lsh">
                  Pay a little upfront and pay the rest once the work is done!
                  All payments are securely processed online so everything is safe and easy.
                </p>
              </div>
            </li>
            <li>
              <div className={`${styles.number} bold`}>3</div>
              <div className={styles.image}><img src={partnerImage} alt="project manager and designer" /></div>
              <div className={styles.description}>
                <h3 className="bold">partner with your project manager and cast your vision</h3>
                <p className="lsh">
                  Each project is managed by us to ensure timeliness and quality.
                  We do the job of finding you the perfect designer and monitor their work in house.
                </p>
              </div>
            </li>
            <li>
              <div className={`${styles.number} bold`}>4</div>
              <div className={styles.image}><img src={receiveImage} alt="satisfaction guaranteed" /></div>
              <div className={styles.description}>
                <h3 className="bold">receive drafts in a week and easily request changes</h3>
                <p className="lsh">
                  Within 7 days you'll receive a first draft concept of your design.
                  If it's not perfect, we'll iterate until it is.
                  Each project has revision time built in to ensure satisfaction.
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default HowItWorks;



// WEBPACK FOOTER //
// ./src/components/HowItWorks/index.js